import { PlatformAgentDerivedKeys } from '@ag-common-lib/public-api';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalWindowComponent } from 'ag-common-svc/lib/components/modal-window/modal-window.component';
import { AgentKeys } from '@ag-common-lib/public-api';
import { AgentSearchService } from 'ag-common-svc/lib/services/agent-search';
import { NotificationRecipientsGridComponent } from '../notification-recipients-grid/notification-recipients-grid.component';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { QueryParam, WhereFilterOperandKeys } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';

@Component({
  selector: 'ag-shr-notification-add-recipients-modal',
  templateUrl: './notification-add-recipients-modal.component.html',
  styleUrls: ['./notification-add-recipients-modal.component.scss'],
})
export class NotificationAddRecipientsModalComponent {
  @ViewChild('notificationAddRecipientsModalRef', { static: false })
  protected notificationAddRecipientsModalComponent: ModalWindowComponent;
  @ViewChild('recipientsGridRef', { static: false })
  protected agentsGridComponent: NotificationRecipientsGridComponent;

  @Input() title = 'Agents';
  @Input() actionTitle = 'Add';
  @Output() handleAddRecipients = new EventEmitter<string[]>();

  protected dataSource = new CustomStore({
    key: 'dbId',
    load: () => {
      // The projection answers "can a push reach them" as its own boolean; the token map
      // itself is jsonb and cannot be filtered.
      return this.agentSearchService
        .search({ filter: [PlatformAgentDerivedKeys.hasFcmTokens, '=', true] })
        .then(response => response?.data ?? []);
    },
  });

  constructor(private agentSearchService: AgentSearchService) {}

  showModal = async (): Promise<void> => {
    this.notificationAddRecipientsModalComponent?.showModal();
  };

  protected addNotificationRecipients = async () => {
    const selectedRowKeys = this.agentsGridComponent.getSelectedRowKeys();

    this.handleAddRecipients.emit(selectedRowKeys);
    this.notificationAddRecipientsModalComponent.forceCloseModal();
  };
}
